import React from 'react';
import banner from '../../assets/images/myProfile.png';
import background from '../../assets/images/background.jpg';
import { TypeAnimation } from 'react-type-animation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faMailForward } from '@fortawesome/free-solid-svg-icons';
const Banner = () => {
    return (
        <section className='flex justify-center w-full lg:sticky top-16 overflow-hidden' style={{ background: `url(${background})` }}>
            <div className="hero-content p-0 flex-col lg:flex-row-reverse lg:justify-around mx-5 max-w-[1400px] w-full lg:mr-20">
                <div data-aos="fade-left" >
                    <h1 className="text-6xl font-bold mt-10 font-play text-transparent bg-clip-text bg-gradient-to-r from-[#ebf9ffcb] to-[#e7f7ffd5] drop-shadow-2xl">Md. Shahariar Rahman</h1>
                    <div className='font-play'>
                        <TypeAnimation
                            sequence={[
                                "Web Developer",
                                3000, // Waits 3s
                                'React Developer',
                                3000, // Waits 3s
                                'Frontend Developer',
                                3000, // Waits 3s
                                'Graduate In CSE',
                                3000, // Waits 3s
                            ]}
                            wrapper="div"
                            cursor={true}
                            repeat={Infinity}
                            // speed={100}
                            style={{ fontSize: '1.5rem', color: '#919ca1', fontWeight: 300 }}
                        />
                    </div>
                    <Link to="/contact" className="btn btn-md glass font-light text-white mt-16 w-full font-play">
                        <span className='animate-pulse'>Contact Me <FontAwesomeIcon className='ml-2 text-green-600 animate-bounce' icon={faMailForward} /></span>
                    </Link>
                </div>
                <img data-aos="fade-right" className="mt-1 lg:ml-20" src={banner} alt='' />
            </div>
        </section>
    );
};

export default Banner;